// extracted by mini-css-extract-plugin
export var downArrow = "_9y-0";
export var infoTooltipIcon = "_9y-3";
export var label = "_9y-1";
export var optionCard = "_9y-4";
export var upArrow = "_9y-2";